import { useNavigate } from "react-router-dom";
export const SettingsRoutesComponent = () => {
	const navigate = useNavigate();
	const ArrayData = [
		{
			label: "General",
			// items: [
			//   {
			//     label: "List",
			//     command: () => {
			//       navigate("/settings/general/list")
			//     },
			//   },
			//   {
			//     label: "Setup",
			//     command: () => {
			//       navigate("/settings/general/setup")
			//     },
			//   },
			// ],
			command: () => {
				navigate("/settings/general/setup");
			},
		},
		{
			label: "Stub",
			command: () => {
				navigate("/settings/stub/setup");
			},
			// items: [
			//   {
			//     label: "List",
			//     command: () => {
			//       navigate("/settings/stub/list")
			//     },
			//   },
			//   {
			//     label: "Setup",
			//     command: () => {
			//       navigate("/settings/stub/setup")
			//     },
			//   },
			// ],
		},
		{
			label: "Cheque",
			command: () => {
				navigate("/settings/cheque/setup");
			},
			// items: [
			//   {
			//     label: "List",
			//     command: () => {
			//       navigate("/settings/cheque/list")
			//     },
			//   },
			//   {
			//     label: "Setup",
			//     command: () => {
			//       navigate("/settings/cheque/setup")
			//     },
			//   },
			// ],
		},
		{
			label: "Statutory Holiday",
			command: () => {
				navigate("/settings/statutory-holiday");
			},
		},

		{
			label: "Year To Date",
			items: [
				{
					label: "Payroll ",
					command: () => {
						navigate(`/settings/year-to-date/payroll`);
					},
				},
				{
					label: "Import",
					command: () => {
						navigate("/settings/year-to-date/import");
					},
				},
				{
					label: "Remittance",
					command: () => {
						navigate("/settings/year-to-date/remittance");
					},
				},
			],
		},
	];

	return {
		SettingsRoutes: ArrayData,
	};
};
